{
    "login": {
        "heading": "Form Builder",
        "lead": "Build beautiful forms easily.",
        "forgotLink": "Forgot Password?",
        "registerLink": "Request Access",
        "username": "Username",
        "usernamePlaceholder": "name@mail.com",
        "password": "Password",
        "passwordPlaceholder": "Password",
        "identityError": "The password you entered is incorrect.",
        "signInLoading": "Signing in…",
        "signInLabel": "Sign in",
        "signInOidcLabel": "Sign in with OIDC Provider"
    },
    "modal": {
        "confirm": {
            "ok": "Ok",
            "cancel": "Cancel"
        },
        "form": {
            "submit": "Submit"
        }
    },
    "explorer": {
        "add": "Add"
    }
}